<!--
 * @Description: 导入日志
-->

<template>
  <div class="my-table-wrap">
    <el-table style="width: 100%" size="small" height="500" border v-loading="loading" :data="listData" :cell-class-name="addClass">
      <el-table-column type="index" width="60" align="center" :label="$lang('序号')"></el-table-column>
      <template v-for="(item, index) in column">
        <el-table-column v-if="!item.hide" :key="index" :prop="item.prop" :label="item.label" :width="item.width + 'px'">
          <template v-if="item.children">
            <template v-for="(item, index) in item.children">
              <el-table-column :key="index" :prop="item.prop" :label="item.label">
                <template slot-scope="{ row }">
                  <el-tooltip v-if="row.failMsgMap && row.failMsgMap[item.prop]" class="item" effect="dark" placement="top-start" :content="row.failMsgMap[item.prop]">
                    <span>{{ row[item.prop] !== null ? row[item.prop] : '--' }}</span>
                  </el-tooltip>
                  <span v-else>{{ row[item.prop] !== null ? row[item.prop] : '--' }}</span>
                </template>
              </el-table-column>
            </template>
          </template>
          <template slot-scope="{ row, column }">
            <el-tooltip v-if="row.failMsgMap && row.failMsgMap[column.property]" class="item" effect="dark" placement="top-start" :content="row.failMsgMap[column.property]">
              <span>{{ row[item.prop] !== null ? row[item.prop] : '--' }}</span>
            </el-tooltip>
            <span v-else>{{ row[item.prop] !== null ? row[item.prop] : '--' }}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div class="pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="page.current"
        :page-size="page.size"
        :page-sizes="page.pageSizes"
        :total="page.total"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { RESPONSE_CODE } from '@public/http/config'
import { setTimeout } from 'timers'
export default {
  name: 'InputData',
  props: {
    // 接口参数
    IPUT_FORM: {
      type: Object
    },
    // 列表参数
    column: {
      type: Array
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false, // 绑定dialog开关 动态启停定时器
      showDialog: false,
      listData: [],
      page: {
        current: 1,
        size: 20,
        total: 0
      },
      emptyText: this.$lang('数据正在导入中请稍后...')
    }
  },
  methods: {
    // 添加样式
    addClass({ row, column, rowIndex, columnIndex }) {
      const failMsgMap = row.failMsgMap
      const indexList = []
      for (const item in failMsgMap) {
        failMsgMap[item] && indexList.push(item)
      }
      console.log('indexList', indexList)
      if (indexList.includes(column.property)) {
        return 'cell-blue'
      }
    },
    async getListData(pageType) {
      // 传入参数有current
      // const params = { ...this.page, modelType: this.modelType }
      try {
        this.loading = true
        // const params = {
        //   current: this.page.current,
        //   size: this.page.size,
        //   pageType: this.pageType,
        //   ...this.params
        // }
        const { code, data, msg } = await this.IPUT_FORM.reqInputList({ pageType: this.pageType })
        setTimeout(() => {
          this.loading = false
          if (code === RESPONSE_CODE.SUCCESS) {
            const dataList = data.page
            this.$emit('inputInfo', data)
            this.listData = dataList.records || []
            this.page.total = dataList.total || 0
            this.page.current = dataList.current || 1
            // this.emptyText = this.listData.length ? this.$lang('数据正在导入中请稍后...') : this.$lang('暂无数据')
          } else {
            this.$message.error(msg)
            clearInterval(this.timer)
          }
        })
      } catch (error) {
        console.error(error)
        clearInterval(this.timer)
        this.loading = false
      }
    },
    // 选择分页条数
    sizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.getListData()
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.getListData()
    },
    // 触发按钮查询
    searchChange() {
      this.page.current = 1
      this.getListData()
    },
    open(type) {
      this.showDialog = true
      this.pageType = type
      this.getListData()
    },
    clearData() {
      this.listData = []
      this.page = {
        current: 1,
        size: 20,
        total: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.my-table-wrap {
  .pagination {
    text-align: right;
    margin-top: 10px;
  }
  .el-table--border th.gutter:last-of-type {
    width: 16px !important;
  }
}
.network-download-dialog {
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
